import { useMutation } from "@tanstack/react-query";
import classNames from "classnames";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import LoadingButton from "../../../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../../../function/helper";
import style from "./PayLinkModal.module.css";

export default function PayLinkModal({ onClose, sender, getters }) {
  const navigate = useNavigate();
  const [payLinkType, setPayLinkType] = useState(0);

  const { mutate, isPending } = useMutation({
    mutationKey: ["PayLinkModal"],
    mutationFn: () =>
      postRequestByAuth("/totalpost/v1/payLink/agent/sendSMS", {
        payLinkType,
        sender,
        getters,
      }).then(res => {
        if (res && res.status === 200) {
          Swal.fire({
            icon: "success",
            text: res.data.message,
            confirmButtonText: "متوجه شدم",
            confirmButtonColor: "green",
          }).then(() => navigate("/payLink/agent/orders"));
          return;
        }

        Swal.fire({
          icon: "error",
          text: res.message,
          confirmButtonText: "متوجه شدم",
          confirmButtonColor: "red",
        });
      }),
  });

  const onSelect = type => {
    if (type === 1) {
      if (payLinkType === 0) {
        setPayLinkType(1);
      } else if (payLinkType === 1) {
        setPayLinkType(0);
      } else if (payLinkType === 2) {
        setPayLinkType(3);
      } else if (payLinkType === 3) {
        setPayLinkType(2);
      }

      return;
    }

    if (type === 2) {
      if (payLinkType === 0) {
        setPayLinkType(2);
      } else if (payLinkType === 1) {
        setPayLinkType(3);
      } else if (payLinkType === 2) {
        setPayLinkType(0);
      } else if (payLinkType === 3) {
        setPayLinkType(1);
      }

      return;
    }
  };

  const onConfirm = () => {
    if (!payLinkType) {
      Swal.fire({
        icon: "warning",
        text: "انتخاب شخص الزامی",
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
    mutate();
  };

  return (
    <Modal show centered={true} size="lg">
      <Modal.Header>
        <h4 className="mb-0">ارسال لینک پرداخت</h4>
      </Modal.Header>

      <Modal.Body className="bs">
        <div className="mb-2">
          <span>شما می‌توانید با انتخاب شخص زیر، </span>
          <strong>پیامکی </strong>
          <span>به عنوان لینک پرداخت ارسال نمایید </span>
          <p className="mb-0">
            و پس از پرداخت و دریافت بارکد توسط شخص انتخابی، امکان پرینت فاکتور
            برای شما فعال می‌شود
          </p>
        </div>

        <p>
          <strong>
            توجه داشته باشید که پس از تکمیل درگاه بانکی، ابتدا کیف پول شما شارژ
            می‌شود و سپس برای پرداخت، هزینه فاکتور کسر می‌شود
          </strong>
        </p>

        <div>
          <p className="mb-0">انتخاب شخص</p>

          <button
            onClick={() => onSelect(1)}
            className={classNames(
              "buttonUi mb-2",
              style.box,
              [1, 3].includes(payLinkType) ? style.boxActive : ""
            )}
          >
            <div
              className={classNames(
                style.circle,
                [1, 3].includes(payLinkType) ? style.circleActive : ""
              )}
            />
            <div>
              <span>فرستنده: </span>
              <strong>{sender.fullName}</strong>
            </div>

            <div>
              <span>موبایل: </span>
              <strong>{sender.mobile}</strong>
            </div>

            <div>
              <span>شماره سفارشات: </span>
              <strong>
                {sender.numberParcels.map(
                  (item, idx) =>
                    item + (idx < sender.numberParcels.length - 1 ? " | " : "")
                )}
              </strong>
            </div>
          </button>

          <button
            onClick={() => onSelect(2)}
            className={classNames(
              "buttonUi",
              style.box,
              [2, 3].includes(payLinkType) ? style.boxActive : "",
              "flex-row"
            )}
          >
            <div
              className={classNames(
                style.circle,
                [2, 3].includes(payLinkType) ? style.circleActive : ""
              )}
            />

            <div style={{ width: "calc(100% - 32px)" }}>
              {getters.map((getter, idx) => (
                <div
                  key={idx}
                  className={classNames(
                    style.box,
                    "p-0",
                    idx < getters.length - 1 ? "pb-1" : ""
                  )}
                >
                  <div>
                    <span>گیرنده: </span>
                    <strong>{getter.fullName}</strong>
                  </div>

                  <div>
                    <span>موبایل: </span>
                    <strong>{getter.mobile}</strong>
                  </div>

                  <div>
                    <span>شماره سفارشات: </span>
                    <strong>
                      {getter.numberParcels.map(
                        (item, idx) =>
                          item +
                          (idx < getter.numberParcels.length - 1 ? " | " : "")
                      )}
                    </strong>
                  </div>
                </div>
              ))}
            </div>
          </button>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <LoadingButton
          center
          type="button"
          className="btn-purple"
          isLoading={isPending}
          title="تایید و ارسال"
          onClick={onConfirm}
        />

        <button
          disabled={isPending}
          onClick={onClose}
          className="btn btn-orange me-auto"
        >
          خروج
        </button>
      </Modal.Footer>
    </Modal>
  );
}
